import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFLags } from '../../hooks/useFeatureFlags';

export const Chatbot = () => {
  const { rtvWebCxOneChatBot } = useFeatureFLags();
  const location = useLocation();
  // VERGIC ENGAGE
  useEffect(() => {
    if (rtvWebCxOneChatBot == null) {
      return;
    }
    if (rtvWebCxOneChatBot) {
      loadCXOneBot();
    }
  }, [rtvWebCxOneChatBot]);

  // for triggering rules to work on url's we need to do this
  useEffect(() => {
    if ('cxone' in globalThis && cxone) {
      cxone('analytics', 'sendPageView', { url: window.location.origin + location.pathname });
    }
  }, [location.pathname]);
  return null;
};

// define types for the global cxone object
declare const cxone: undefined | ((...args: any[]) => void);

/** Open chat programmatically  */
//  document.querySelector('<some button selector>')?.addEventListener('click', () => {
//    const selector = 'button[data-selector="GUIDE_CHANNEL_BUTTON"]';
//    document.querySelector(selector)?.click?.();
//  });

const loadCXOneBot = () => {
  const id = 'cxone-chatbot';
  if (document.getElementById(id)) {
    // script already loaded
    return;
  }
  // docs: https://static.dev.rikstv.no/web/cxone/readme.md
  const cssHref = 'https://static.rikstv.no/web/cxone/rikstv.css';
  const scriptSrc = 'https://static.rikstv.no/web/cxone/init.js';
  document.head.insertAdjacentHTML('beforeend', `<link id="style-${id}" rel="stylesheet" href="${cssHref}" />`);
  const script = document.createElement('script');
  script.id = id;
  script.src = scriptSrc;
  document.head.appendChild(script);
};
